export default __webpack_public_path__ + "assets/models/221c70c8b0054bbbd104ac50a27dd655.glb";